import { Validators } from '../../../utils/validators';
import { FormModel } from '../../../components/Form';
import { CountryCode } from 'libphonenumber-js';
import strings from '../../../common/Translation/Translate';

export const AddUserForm = (
  salutations: any[],
  roles: any[],
  countries: any[],
  states: any[],
  cities: any[],
  assignees: any[],
  defaultCountry: CountryCode,
  autoFocus: boolean = false,
): FormModel[] => {
  return [
    {
      label: strings.users_salutation,
      placeholder: strings.users_salutation,
      value: '',
      size: 'medium',

      type: 'select',
      field: 'title',
      validators: [],
      required: false,
      isMulti: false,
      isClearable: true,
      responsive: { xs: 12, sm: 4 },
      options: salutations,
    },
    {
      label: strings.usermgmt_text_firstName,
      value: '',
      size: 'medium',
      autoFocus: autoFocus,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'firstName',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      responsive: { xs: 12, sm: 4 },
      required: true,
    },
    {
      label: strings.usermgmt_text_lastName,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'lastName',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      responsive: { xs: 12, sm: 4 },
      required: true,
    },
    {
      label: strings.emailText,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'email',
      validators: [
        { check: Validators.validateMandatoryField },
        { check: Validators.validateEmail },
        { check: Validators.validateString },
      ],
      responsive: { xs: 12, sm: 4 },
      required: true,
    },
    {
      label: strings.customerDetailsPhoneNumber,
      value: {},
      size: 'medium',
      type: 'phoneInput',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'phone',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateMobile }],
      responsive: { xs: 12, sm: 4 },
      required: true,
      defaultCountry: defaultCountry,
    },
    {
      label: strings.customerDetailsRoles,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'roles',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 4 },
      required: true,
      options: roles,
    },
    {
      label: strings.usermgmt_text_designation,
      value: '',
      size: 'medium',
      type: 'text',
      placeholder: '',
      field: 'designation',
      validators: [{ check: Validators.validateString, max: 50 }],
      responsive: { xs: 12, sm: 4 },
      required: false,
      options: roles,
    },
    {
      label: strings.updateProfile_text_language,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.updateProfile_text_language,
      field: 'language',
      validators: [],
      responsive: { xs: 12, sm: 4 },
      required: false,
      isMulti: false,
    },
    {
      label: null,
      value: null,
      type: 'divider',
      placeholder: '',
      field: null,
      validators: [],
      required: false,
      responsive: { xs: 12 },
    },
    {
      label: strings.updateProfile_text_org,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.updateProfile_text_org,
      field: 'organizations',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6 },
      required: true,
      isMulti: true,
    },
    {
      label: strings.users_reporting_to,
      placeholder: strings.users_reporting_to,
      value: '',
      size: 'medium',
      type: 'select',
      field: 'reportingTo',
      validators: [],
      responsive: { xs: 12, sm: 6 },
      required: false,
      isMulti: true,
      isClearable: true,
      options: assignees,
    },
    {
      label: null,
      value: null,
      type: 'divider',
      placeholder: '',
      field: null,
      validators: [],
      required: false,
      responsive: { xs: 12 },
    },
    {
      label: strings.updateProfile_text_address,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'address',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      responsive: { xs: 12, sm: 4 },
      required: true,
    },
    {
      label: strings.updateProfile_text_country,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'country',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 4 },
      required: true,
      options: countries,
    },
    {
      label: strings.updateProfile_text_state,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'state',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 4 },
      required: true,
      options: states,
    },
    {
      label: strings.updateProfile_text_city,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'city',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 4 },
      required: true,
      options: cities,
    },
    {
      label: strings.updateProfile_text_pinCode,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'pinCode',
      validators: [{ check: Validators.validatePinCode }],
      responsive: { xs: 12, sm: 4 },
      required: false,
    },
  ];
};
